module.exports = __webpack_public_path__ + "img/home-slider-smoke.268cb72a.png";